import { Injectable } from '@angular/core';
import { getCookie, setCookie, removeCookie } from 'typescript-cookie';
import { JwtPayload, jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor() { }

  /**
   * `sessionStorage` no existe en el servidor. Las páginas públicas se prerenderizan en el
   * build (app.routes.server.ts) y el interceptor que usa este servicio corre en cada
   * pedido HTTP: sin esta guarda, el pedido tiraba ReferenceError y el prerender del
   * marketplace quedaba colgado hasta el timeout.
   */
  private get store(): Storage | null {
    return typeof sessionStorage !== 'undefined' ? sessionStorage : null;
  }

  saveToken(token: string): void {
    this.store?.setItem('token', token);
  }

  getToken(): string {
    return this.store?.getItem('token') || '';
  }

  removeToken(): void {
    this.store?.removeItem('token');
  }

  isValidToken(): boolean {
    const token = this.getToken();
    if (!token) return false;
    const decodeToken = jwtDecode<JwtPayload>(token);
    if (decodeToken && decodeToken?.exp) {
      const tokenDate = new Date(0);
      tokenDate.setUTCSeconds(decodeToken.exp);
      const today = new Date();
      return tokenDate.getTime() > today.getTime();
    }
    return false;
  }

  /* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */


  saveRefeshToken(token: string): void {
    setCookie('refresh-token-cook', token, { expires: 1, path: '/' });
  }

  getRefeshToken(): string {
    return getCookie('refresh-token-cook') || '';
  }

  removeRefeshToken(): void {
    removeCookie('refresh-token-cook');
  }

  isValidRefreshToken(): boolean {
    const token = this.getRefeshToken();
    if (!token) return false;
    const decodeToken = jwtDecode<JwtPayload>(token);
    if (decodeToken && decodeToken?.exp) {
      const tokenDate = new Date(0);
      tokenDate.setUTCSeconds(decodeToken.exp);
      const today = new Date();
      return tokenDate.getTime() > today.getTime();
    }
    return false;
  }
}
